import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "alert_investigation_colored",
  "use": "alert_investigation_colored-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 17 16\" id=\"alert_investigation_colored\"><path fill=\"#F06C7D\" d=\"M14.2 9.11a2.61 2.61 0 0 1-1.45-2.34V6c0-1.97-1.44-3.6-3.31-3.93 0-.02.01-.04.01-.07 0-.39-.31-.7-.7-.7s-.7.31-.7.7c0 .02.01.05.01.07C6.19 2.4 4.75 4.03 4.75 6v.76c0 1-.55 1.9-1.45 2.34l-.55.28V10h7.5c0 .55-.45 1-1 1h-6.5v1.2c0 .99.81 1.8 1.8 1.8h3.2c0 .55.45 1 1 1s1-.45 1-1h3.2c.99 0 1.8-.81 1.8-1.8V9.38z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol